import { ShieldOffIcon } from "lucide-react"
import { useTranslation } from "react-i18next"

/**
 * PDD §11.2 state 6. Names the permission required and who can grant it, so the
 * user's next action is obvious. This is a designed screen, not a dead end.
 */
export function PermissionDenied({ required }: { required: readonly string[] }) {
  const { t } = useTranslation("common")
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-4 py-24 text-center">
      <ShieldOffIcon className="size-10 text-muted-foreground" aria-hidden />
      <h1 className="text-lg font-medium">{t("permissionDenied.title")}</h1>
      <p className="text-sm text-muted-foreground">{t("permissionDenied.body")}</p>
      {required.length > 0 ? (
        <code className="numeric rounded-md bg-muted px-3 py-2 text-xs">{required.join(", ")}</code>
      ) : null}
    </div>
  )
}
